import React from 'react';
import {
  Row,
  Col,
  Panel,
  FormGroup,
  Checkbox,
  Button,
  Radio
} from 'react-bootstrap';
import FieldGroup from '../../../components/FieldGroup';
import SearchWaitlist from './SearchWaitlist';
import BucketFilters from './BucketFilters';
import AssigneeFilters from './AssigneeFilters';
import CompletionFilters from './CompletionFilters';
import ProfileFilters from './ProfileFilters';
import ApplyFiltersButton from './ApplyFiltersButton';

class WaitlistFilters extends React.Component {
  render() {
    return (
      <Row className="show-grid">
        <Col md={12}>
          <Panel header="Filters">
            <Row className="show-grid">
              <SearchWaitlist
                searchValue={this.props.searchValue}
                updateSearch={this.props.updateSearch}
                submitSearch={this.props.submitSearch}
              />
              <BucketFilters
                selectedBuckets={this.props.filters.buckets}
                addBucket={bucket =>
                  this.props.addCheckboxFilter('buckets', bucket)
                }
                removeBucket={bucket =>
                  this.props.removeCheckboxFilter('buckets', bucket)
                }
              />
              <AssigneeFilters
                selectedAssginees={this.props.filters.assignees}
                addAssignee={assignee =>
                  this.props.addCheckboxFilter('assignees', assignee)
                }
                removeAssignee={assignee =>
                  this.props.removeCheckboxFilter('assignees', assignee)
                }
              />
              <CompletionFilters
                selectedCompletion={this.props.filters.completion}
                addCompletion={completion =>
                  this.props.addCheckboxFilter('completion', completion)
                }
                removeCompletion={completion =>
                  this.props.removeCheckboxFilter('completion', completion)
                }
              />
              <ProfileFilters
                selectedProfiles={this.props.filters.profiles}
                updateProfiles={profiles =>
                  this.props.updateRadioFilter('profiles', profiles)
                }
              />
              <ApplyFiltersButton applyFilters={this.props.applyFilters} />
            </Row>
          </Panel>
        </Col>
      </Row>
    );
  }
}

export default WaitlistFilters;
